import * as React from "react";
import Store from "logic/local-storage/Store";
import { Modal, Col, Row } from "components/bootstrap";
import { PaginationProvider, SelectedRowsProvider, ModalProvider } from "common/contexts";
import AlertsEntityTable from "security-app/components/SecurityEvents/Alerts/AlertsEntityTable";
import { LOCAL_STORAGE_ITEM } from "security-app/hooks/api/securityEventsAPI.types";
const EventsModal = ({ show, onCancel }) => {
  const lastSearch = Store.get(LOCAL_STORAGE_ITEM);
  const onClose = () => {
    onCancel();
  };
  return /* @__PURE__ */ React.createElement(Modal, { show, bsSize: "xlarge", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add Events")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
    PaginationProvider,
    {
      initFilters: lastSearch ? { alerts: lastSearch.alerts, timerange: lastSearch.timerange } : {}
    },
    /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(AlertsEntityTable, null)))))
  )));
};
export default EventsModal;
